import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import {
  HeaderTitle,
  Table,
  Scroll,
  Message,
  Card,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import { format } from "date-fns";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { Spin } from "antd";
import { Container } from "./styles";
import CountUp from "react-countup";

dayjs.extend(weekday);
dayjs.extend(localeData);

const Comunicado = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [statement, setStatement] = useState({});
  const [users, setUsers] = useState([]);

  useEffect(() => {
    loadStatement();
  }, []);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadStatement() {
    await api
      .get(`/statement/${id}`)
      .then((response) => {
        setStatement(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return (
    <Container>
      <h1>Comunicado e Confirmações</h1>
      <Card>
        <p>Total</p>
        <CountUp
          duration={1}
          end={statement.statement_confirms?.length || 0}
          suffix={"/" + users.length}
          separator="."
        />
      </Card>
      {!isLoading && (
        <>
          {users?.length ? (
            <>
              <h3>{statement.title}</h3>
              <p>{statement.description}</p>
              <Scroll>
                <Table>
                  <thead>
                    <tr>
                      <td>Franqueado</td>
                      <td>Presença</td>
                      <td>Data de Confirmação</td>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user.id}>
                        <td>{user.name}</td>
                        <td>
                          {statement.statement_confirms.some(
                            (item) => user.id == item.user_id
                          )
                            ? "Confirmado"
                            : "Pendente"}
                        </td>
                        <td>
                          {statement.statement_confirms.find(
                            (item) => user.id == item.user_id
                          )
                            ? format(
                                new Date(
                                  statement.statement_confirms.find(
                                    (item) => user.id == item.user_id
                                  ).date
                                ),
                                "dd/MM/yyyy HH:mm"
                              )
                            : "Sem data"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scroll>
            </>
          ) : (
            <Message>Ocorreu um erro ao carregar franqueados</Message>
          )}
        </>
      )}
      {isLoading && <Spin style={{ marginTop: 50 }} />}
    </Container>
  );
};

export default Comunicado;
